<template>
  <smd-one-col-layout class="preview-file"
                      content-styles="full-width">
    <smd-header slot="header" nav>
      <smd-btn class="reset-mp"
               clean
               slot="left-actions">
        <span class="ns-icon-ico028"
              @click="goBack"/>
      </smd-btn>
      <div class="Title3 gray-400 text-center">
        {{ title }}
      </div>

      <template slot="right-actions">
        <div class="flex-row-center-xy-spaced">
          <smd-btn :class="$isMobile || !showChooseButton ? 'reset-mp': 'reset-m'"
                   clean>
            <span class="ns-icon-ico045"
                  v-if="!isPrescriptionFile"
                  @click="viewPrescriptionExternal"/>

          </smd-btn>
          <smd-btn v-if="!$isMobile && showChooseButton"
                   @click="onCouponClick">
            <text-string label-id="txt298"/>
          </smd-btn>
        </div>
      </template>
    </smd-header>
    <div class="preview-file__viewer"
         :class="computedClass">

      <full-screen-loader v-if="isLoading"/>
      <template v-else>
        <template v-show="!isPreviewImage">
          <pdf style="height: 100%"
               v-for="i in numPages"
               :key="i"
               :page="i"
               :src="pdfSrc"/>
        </template>

        <img v-show="isPreviewImage" ref="imagePreview" src="" width="100%" height="auto"/>

        <div class="file-selected" v-show="!pdfSrc && !this.isPreviewImage">
          <p>File selected</p>
          <p>Name:</p>
          <p> {{ pdfFileName }}</p>
        </div>
      </template>
    </div>
    <div class="preview-file__bottom-nav"
         v-if="showCouponButton"
         slot="bottom-nav">
      <smd-btn type="button"
               section="4"
               variant="green-enabled"
               class="preview-file__lab-request-coupon-btn"
               @click="onCouponClick">
        <div class="logo">
          <img src="@/assets/images/img007.png" alt="Hi-pres Logo">
        </div>
        <text-string :label-id="buttonLabelId"/>
      </smd-btn>
    </div>
    <div class="preview-file__bottom-nav"
         v-if="showChooseButton && !$isDesktop"
         slot="bottom-nav">
      <smd-btn section="1"
               variant="blue"
               @click="onCouponClick">
        Choose
      </smd-btn>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import PreviewFileMixin from '../mixins/preview-file-mixin';
  import LabRequestCouponMixin from "@/mixins/lab-request-coupon-mixin";
  import ShowModalInstructionsMixin from "@/mixins/show-modal-instructions-mixin";

  import GetElementString from "@/mixins/get-element-string";
  import {
    HIPRES_INSTRUCTION_ITEM,
    MODAL_LOCAL_STORAGE_KEYS,
  } from "@/reference/modal-instruction-items";
  import ModalInstructions from "@/modals/modal-instructions/modal-instructions";
  import {Reference} from "smd-vue-scaffold";
  import {FilesService} from "@/services/files";
  import {PageTypes} from "@/reference";

  export default {
    name: "preview-file-lab-request",
    mixins: [
      PreviewFileMixin,
      GetElementString,
      LabRequestCouponMixin,
      ShowModalInstructionsMixin
    ],
    props: {
      showCouponButton: {type: Boolean, default: true},
      showChooseButton: {type: Boolean, default: false},
      forceClaim: {type: Boolean, default: false}
    },
    computed: {
      buttonLabelId() {
        return this.file[this.fileArrayIndex].orderid ? 'txt1424' : 'txt1411';
      },
    },
    methods: {
      async fetchFileURL(token, uploadid) {
        try {
          const {data} = this.file[this.fileArrayIndex].pagetype === PageTypes.__labresults
            ? await FilesService.getLabResultFileURL(uploadid)
            : await FilesService.getFileURL(token, uploadid);

          if (!data) {
            throw Error();
          }

          return data.url
        } catch (e) {
          console.error(e);
        }
      },
      onCouponClick() {
        if (this.loading) return;

        if (this.forceClaim) {
          this.claimCoupon(this.file[this.fileArrayIndex].token, this.file[this.fileArrayIndex].uploadid);
        } else if (this.file[this.fileArrayIndex].orderid) {
          this.viewOrderDetails(this.file[this.fileArrayIndex].token, this.file[this.fileArrayIndex].orderid);
        } else {
          if (this.showModalInstructions(MODAL_LOCAL_STORAGE_KEYS.HIPRES)) {
            this.$modal.open({
              component: ModalInstructions,
              position: 'detached auto-height',
              props: {
                items: HIPRES_INSTRUCTION_ITEM,
                mainTitle: 'txt348',
                modalLocalStorageKey: MODAL_LOCAL_STORAGE_KEYS.HIPRES
              },
              onClose: ({success}) => {
                if (success) {
                  this.claimCoupon(this.file[this.fileArrayIndex].token, this.file[this.fileArrayIndex].uploadid);
                }
              },
              size: Reference.SmdModalSizes.xs,
            })
          } else {
            this.claimCoupon(this.file[this.fileArrayIndex].token, this.file[this.fileArrayIndex].uploadid);
          }
        }
      },

    },
  }
</script>

<style>
</style>